import { OptionalLink } from 'components/Link';
import { ProductSectionTags } from 'components/Product';
import ProductTag from 'components/ProductTag';
import Rating from 'components/Rating';
import Text from 'components/Text';
import type {
	Brand,
	ProductTag as ProductTagModel,
	ReviewScoreDistribution,
	VariantId,
} from 'models/product';
import { useI18n } from 'utils/i18n';

import { useReviewContext } from './ProductDetailsContext';

interface Props {
	brand: Brand | undefined;
	id: VariantId;
	productModel: string | undefined;
	reviewScore: ReviewScoreDistribution | undefined;
	tags: ProductTagModel[] | undefined;
	variantModel: string | undefined;
}

export default function ProductDetailsIntro({
	brand,
	id,
	productModel,
	reviewScore,
	tags,
	variantModel,
}: Props) {
	const { t } = useI18n();
	const { openReviewsPopover } = useReviewContext();
	const model = variantModel || productModel;
	const flag = tags?.find(({ section }) => section === 'Flag');

	return (
		<>
			{brand?.title && (
				<>
					{model && (
						<p>
							<OptionalLink underline href={brand.relativeUrl} fallback={null}>
								{brand.title}
							</OptionalLink>
							{!brand.relativeUrl && <span className="sr-only">, </span>}
							<span aria-hidden>{' | '}</span>
							{model}
						</p>
					)}
					{!model && (
						<OptionalLink underline href={brand.relativeUrl} fallback="p">
							{brand.title}
						</OptionalLink>
					)}
				</>
			)}
			<Text as="p" className="mt-2">
				{t('general_article_number_label')}: {id}
			</Text>
			<div className="mt-4">
				{reviewScore?.score && reviewScore.score > 0 ? (
					<Rating
						reviewCountVariant="fullText"
						onClick={openReviewsPopover}
						score={reviewScore.score}
						reviewCount={reviewScore.count}
					/>
				) : (
					<div className="h-6" />
				)}
			</div>
			<ProductSectionTags productTags={tags} className="mt-4" />
			{flag && (
				<ProductTag
					type={flag.type}
					text={flag.text}
					size="lg"
					className="mt-2"
				/>
			)}
		</>
	);
}
ProductDetailsIntro.displayName = 'ProductDetailsIntro';
